var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, createSvgIcon, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CirclesSelect } from "hx-ui";
import { useStyledModal } from "@/components/modals/styled-modal.hook";
import { useCustomValidationField } from "hx-util";
import { PlayMode, usePreviewLoop } from "hx-din-test-2";
import { UserSoundLeft } from "./user-sound-left.component";
import { UserSoundBoth } from "./user-sound-both.component";
import { UserSoundRight } from "./user-sound-right.component";
import { HeadphoneCheckModalContent } from "./headphone-check-modal-content.component";
var SoundLeftIcon = createSvgIcon(_jsx(UserSoundLeft, {}), 'SoundLeft');
var SoundBothIcon = createSvgIcon(_jsx(UserSoundBoth, {}), 'SoundBoth');
var SoundRightIcon = createSvgIcon(_jsx(UserSoundRight, {}), 'SoundRight');
export function HeadphoneCheckContent() {
    var _a = useStyledModal({
        header: 'Troubleshooting',
        content: _jsx(HeadphoneCheckModalContent, {}),
        buttonProps: {
            text: 'Dismiss'
        }
    }), styledModal = _a.styledModal, toggleStyledModal = _a.toggleStyledModal;
    var theme = useTheme();
    var _b = useCustomValidationField({
        validationFieldName: 'headphone-check-valid',
        fieldName: 'headphone-check',
        validationFunction: function (value) {
            return value !== 'both' && value !== 'right';
        },
    }), validate = _b.validate, error = _b.error;
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    usePreviewLoop({
        autoPlay: true,
        config: {
            playMode: PlayMode.MonoauralLeft,
        },
    });
    return _jsxs("div", __assign({ className: "grid gap-2 md:gap-4 md:px-6 place-items-center" }, { children: [_jsx("div", __assign({ className: "grid place-items-center" }, { children: _jsx(CirclesSelect, { routeClass: 'grid-cols-1 gap-10 sm:gap-8 sm:grid-cols-3', controllerProps: {
                        name: 'headphone-check',
                        rules: {
                            required: 'Please select an option before continuing',
                            validate: validate,
                        },
                    }, itemStyles: {
                        svg: {
                            stroke: 'var(--circle-select-color)',
                            strokeWidth: 1.5,
                            width: isMobile ? '32px' : '40px',
                            height: isMobile ? '32px' : '40px',
                        },
                        '&[data-state="checked"]': {
                            svg: { stroke: 'white', color: 'white' },
                            border: '3px solid white',
                        },
                        '&:focus': {},
                        '&:hover': {
                            backgroundColor: 'var(--circle-select-color)',
                            svg: { stroke: 'white', color: 'white' },
                            border: '3px solid white',
                            opacity: 0.8,
                        },
                        height: isMobile ? '4rem' : '6rem',
                        width: isMobile ? '4rem' : '6rem',
                        boxShadow: 'none',
                        borderWidth: 3
                    }, options: [
                        {
                            value: 'left',
                            label: 'Left',
                            icon: _jsx(SoundLeftIcon, { sx: {
                                    height: isMobile ? '1.25rem' : '2.5rem',
                                    width: isMobile ? '1.25rem' : '2.5rem'
                                }, color: "primary" }),
                        },
                        {
                            value: 'both',
                            label: 'Both',
                            icon: _jsx(SoundBothIcon, { sx: {
                                    height: isMobile ? '1.25rem' : '2.5rem',
                                    width: isMobile ? '1.25rem' : '2.5rem'
                                }, color: "primary" }),
                        },
                        {
                            value: 'right',
                            label: 'Right',
                            icon: _jsx(SoundRightIcon, { sx: {
                                    height: isMobile ? '1.25rem' : '2.5rem',
                                    width: isMobile ? '1.25rem' : '2.5rem'
                                }, color: "primary" }),
                        },
                    ], labelProps: {
                        className: 'font-[Inter]',
                    } }) })), _jsxs("div", __assign({ className: 'mt-6 flex flex-col items-center gap-3' }, { children: [_jsx(Button, __assign({ variant: 'text', onClick: function () { return toggleStyledModal(); }, className: 'underline font-medium text-charcoal hover:bg-transparent hover:font-bold' }, { children: "Still no sound?" })), !!error && _jsx(Typography, __assign({ className: 'text-red' }, { children: "Your headphones may not be compatible. Try reconnecting or use a different pair." }))] })), styledModal] }));
}
